import { Typography } from "antd"
import cls from "classnames"
import { useSelector } from "react-redux"

import { formatCurrency } from "../../../../Utils/utils"

import "./styles.less"

const { Text } = Typography

const MileStonesComponent = ({ mileStones, current }) => {
  const getCurMileStoneProgress = (mileStone) => {
    if (current >= mileStone.alerts) return 100
    const prevMileStone = mileStones.find((s) => s.order === mileStone.order - 1)
    if (!prevMileStone) return (current / mileStone.alerts) * 100
    const range = mileStone.alerts - prevMileStone.alerts
    const progressInRange = current - prevMileStone.alerts
    if (progressInRange <= 0) return 0
    return (progressInRange / range) * 100
  }

  const isAllMilestonesAchieved = mileStones.every((s) => s.alerts <= current)
  const isMobile = useSelector((state) => state.nav.isMobile)
  return (
    <>
      {!isMobile ? (
        <div className="milestones-scale">
          <Text className={cls("reward", "label")}>Reward</Text>
          <Text className={cls("alerts", "label")}>Alerts</Text>
          <div className="segments">
            {mileStones.map((s) => (
              <div className="segment" key={s.order}>
                <div className="progress" style={{ width: `${getCurMileStoneProgress(s)}%` }} />
                <div className={cls("circle", { active: s.alerts <= current })} />
                <Text className="label top-label">{formatCurrency(s.reward, true)}</Text>
                <div className="arrow top-arrow" />
                <Text className="label bottom-label">{s.alerts}</Text>
                <div className="arrow bottom-arrow" />
              </div>
            ))}
            <div className="segment">
              <div
                className="progress"
                style={{ width: isAllMilestonesAchieved ? "100%" : "0%" }}
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}

export default MileStonesComponent
